import { createFeature, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CommonState } from '@shared/models/common/common-state';
import { IDossier } from '@features/mes-financements/models/dossier.model';
import { MesFinancementsActions } from '@features/mes-financements/store/financements/mes-financements.actions';

export interface DossierState extends EntityState<IDossier>, CommonState {
  totalElements: number;
  exportLoading: boolean;
}

export const dossierEntityId = (d: Pick<IDossier, 'moduleId' | 'identifiantDossier'>): string =>
  `${String(d.moduleId)}::${String(d.identifiantDossier)}`;

export const entiteAdapter: EntityAdapter<IDossier> = createEntityAdapter<IDossier>({
  selectId: dossierEntityId,
});

const initialState: DossierState = entiteAdapter.getInitialState({
  totalElements: 0,
  loading: true,
  errorMessage: null,
  exportLoading: false
});

export const mesFinancementsReducers = createReducer(
  initialState,
  on(MesFinancementsActions.getDossiersBySearchCriteriaSuccess, (state, { dossiers }) => {
    return entiteAdapter.setAll(dossiers.items, {
      ...state,
      loading: false,
      errorMessage: null,
      totalElements: dossiers.totalElements,
    });
  }),
  on(MesFinancementsActions.getDossiersBySearchCriteriaFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
  on(MesFinancementsActions.updateLoading, (state, { isLoading }) => ({
    ...state,
    loading: isLoading
  })),
  on(MesFinancementsActions.addFinancementToList, (state, { dossier }) =>
    entiteAdapter.addOne(dossier, state),
  ),
  on(MesFinancementsActions.updateFinancementList, (state, { dossier }) =>
    entiteAdapter.upsertOne(dossier, state),
  ),
  on(MesFinancementsActions.deleteDossier, (state, { idDossier, moduleId }) =>
    entiteAdapter.removeOne(`${String(moduleId)}::${String(idDossier)}`, state),
  ),
  on(MesFinancementsActions.updateExportLoading, (state, { isLoading }) => ({
    ...state,
    exportLoading: isLoading
  }))
);

export const mesFinancementsFeature = createFeature({
  name: 'mesFinancements',
  reducer: mesFinancementsReducers,
});
